/** Standard Czech VAT rate applied to course orders (service always performed in Czechia). */
export const courseVatRate = 21;
